/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ModalConfirmEventCtrl', function(
    $scope,
    $routeParams,
    $uibModalInstance,
    $rootScope,
    identity,
    cal_event,
    student_event_conflicts,
    group_event_conflicts,
    ngNotify,
    Planning,
    ErrorThrower
) {

    $scope.me    = identity;
    const errorManager = new ErrorThrower({
        'The event is locked':                     'Le créneau est verrouillé',
        'Registration date passed':                'La date d\'inscription est passée',
        'The event has already been taken':        'Le créneau a déjà été pris',
        'Group not found':                         'Le groupe n\'a pas été trouvé',
        'Group already has a date for this event': 'Le groupe a déjà un créneau pour cet événement'
    });

    $scope.student_event_conflicts = student_event_conflicts;
    $scope.group_event_conflicts   = group_event_conflicts;
    $scope.requesting              = false;
    $scope.cal_event               = cal_event;
    const event_info                     = `\
${cal_event.event.name} pour ${cal_event.event.activity_name},
du ${cal_event.event.start} au ${cal_event.event.end}\
`;

    $scope.cancel = () => $uibModalInstance.dismiss('cancel');

    return $scope.confirm = function() {
        $scope.requesting = true;
        return Planning
        .update({
            login: $scope.me.login,
            id:    cal_event.event.id}).$promise
        .then(function() {
            ngNotify.set(`Inscrit au créneau: ${event_info}`, 'success');
            $uibModalInstance.dismiss('done');
            return $rootScope.$broadcast('refetchEvents');}).catch(function(error) {
            const message = (error.data != null) ? error.data : error.statusText;
            return errorManager.minor(message);}).finally(() => $scope.requesting = false);
    };
});
